import { render } from "./DashboardAdminView.vue?vue&type=template&id=56474649"
import script from "./DashboardAdminView.vue?vue&type=script&lang=js"
export * from "./DashboardAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__